module.exports = __webpack_public_path__ + "static/media/pullup.138e03e8.svg";